<div class="card-default" [ngClass]="ngClass">
  <div (click)="onHeaderClick($event)" class="card-header" [ngClass]="{ mb: !!title }">
    <div class="card-title">{{ title | translate }}</div>
    <div class="card-actions">
      <ng-content select="[header-action]"></ng-content>
    </div>
  </div>
  <div class="card-body">
    <div *ngIf="description" class="card-body-desc" [innerHTML]="description | translate"></div>
    <ng-content></ng-content>
  </div>
  <div *ngIf="showFooter" class="card-footer">
    <ng-content select="[card-footer]"></ng-content>
  </div>
</div>
